import { httpClient } from "utils";

const defaultPathEmissions = "/emissions/v2";
const defaultPathConsumption = "/consumptions/v2";
const defaultPathFinancials = "/financials/v2";

export const DASHBOARD = {
  VARIANCE: "/variance/yoy",
  COMPARISON: "/variance/comparison",
  DATE_RANGE: (chartType: string) => `/range/${chartType}`,
  YOY: (chartType: string) => `/yoy/${chartType}`,
  SCOPE: (chartType: string) => `/scope/${chartType}`
};

export interface DefaultChartDTO {
  countryRegions: string[] | null;
  countries: string[] | null;
  facilityTypes: string[] | null;
  businessUnits: string[] | null;
  scopes: string[] | null;
  utilityTypeIds: number[] | null;
  siteIds: number[] | null;
  accountNumbers: string[] | null;
  meterNumbers: string[] | null;
};

export interface VarianceChartDTO extends DefaultChartDTO {
  compareFromDate: string;
  compareToDate: string;
};

export interface VarianceComparisonDTO extends VarianceChartDTO {
  comparisonPeriod: string;
};

export interface DateRangeDTO extends VarianceChartDTO {
  groupBy: string;
};

export interface YoYDTO extends DefaultChartDTO {
  yearsToCompare: number;
};

export interface SingleYearByScopeDTO extends DefaultChartDTO {
  fiscalYear: string;
};

// VARIANCE UPDATES
export const updateVarianceEmissions = (varianceRequest: VarianceChartDTO) =>
  httpClient.post<VarianceChartDTO>(`${defaultPathEmissions + DASHBOARD.VARIANCE}`, varianceRequest);

export const updateVarianceConsumption = (varianceRequest: VarianceChartDTO) =>
  httpClient.post<VarianceChartDTO>(`${defaultPathConsumption + DASHBOARD.VARIANCE}`, varianceRequest);

export const updateVarianceFinancials = (varianceRequest: VarianceChartDTO) =>
  httpClient.post<VarianceChartDTO>(`${defaultPathFinancials + DASHBOARD.VARIANCE}`, varianceRequest);

export const updateVarianceComparisonEmissions = (comparisonRequest: VarianceComparisonDTO) =>
  httpClient.post<VarianceComparisonDTO>(`${defaultPathEmissions + DASHBOARD.COMPARISON}`, comparisonRequest);

export const updateVarianceComparisonConsumption = (comparisonRequest: VarianceComparisonDTO) =>
  httpClient.post<VarianceComparisonDTO>(`${defaultPathConsumption + DASHBOARD.COMPARISON}`, comparisonRequest);

export const updateVarianceComparisonFinancials = (comparisonRequest: VarianceComparisonDTO) =>
  httpClient.post<VarianceComparisonDTO>(`${defaultPathFinancials + DASHBOARD.COMPARISON}`, comparisonRequest);

// DATE RANGE UPDATES
export const updateDateRangeEmissions = ({ chartType, dateRangeRequest }: { dateRangeRequest: DateRangeDTO, chartType: string }) =>
  httpClient.post<DateRangeDTO>(`${defaultPathEmissions + DASHBOARD.DATE_RANGE(chartType)}`, dateRangeRequest);

export const updateDateRangeConsumption = ({ chartType, dateRangeRequest }: { dateRangeRequest: DateRangeDTO, chartType: string }) =>
  httpClient.post<DateRangeDTO>(`${defaultPathConsumption + DASHBOARD.DATE_RANGE(chartType)}`, dateRangeRequest);

export const updateDateRangeFinancials = ({ chartType, dateRangeRequest }: { dateRangeRequest: DateRangeDTO, chartType: string }) =>
  httpClient.post<DateRangeDTO>(`${defaultPathFinancials + DASHBOARD.DATE_RANGE(chartType)}`, dateRangeRequest);

// YOY UPDATES
export const updateYoYEmissions = ({ chartType, YoYRequest }: { chartType: string; YoYRequest: YoYDTO }) =>
  httpClient.post<YoYDTO>(`${defaultPathEmissions + DASHBOARD.YOY(chartType)}`, YoYRequest);

export const updateYoYConsumption = ({ chartType, YoYRequest }: { chartType: string; YoYRequest: YoYDTO }) =>
  httpClient.post<YoYDTO>(`${defaultPathConsumption + DASHBOARD.YOY(chartType)}`, YoYRequest);

export const updateYoYFinancials = ({ chartType, YoYRequest }: { chartType: string; YoYRequest: YoYDTO }) =>
  httpClient.post<YoYDTO>(`${defaultPathFinancials + DASHBOARD.YOY(chartType)}`, YoYRequest);


// SINGLE YEAR BY SCOPE UPDATES
export const updateSingleYearByScopeEmissions = ({ chartType, singleYearByScopeRequest }: { chartType: string; singleYearByScopeRequest: SingleYearByScopeDTO }) =>
  httpClient.post<SingleYearByScopeDTO>(`${defaultPathEmissions + DASHBOARD.SCOPE(chartType)}`, singleYearByScopeRequest);

export const updateSingleYearByScopeConsumption = ({ chartType, singleYearByScopeRequest }: { chartType: string; singleYearByScopeRequest: SingleYearByScopeDTO }) =>
  httpClient.post<SingleYearByScopeDTO>(`${defaultPathConsumption + DASHBOARD.SCOPE(chartType)}`, singleYearByScopeRequest);

export const updateSingleYearByScopeFinancials = ({ chartType, singleYearByScopeRequest }: { chartType: string; singleYearByScopeRequest: SingleYearByScopeDTO }) =>
  httpClient.post<SingleYearByScopeDTO>(`${defaultPathFinancials + DASHBOARD.SCOPE(chartType)}`, singleYearByScopeRequest);
